var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import C from 'classnames';
import { Button, Input, Form } from '../..';
import { Typeahead } from 'react-bootstrap-typeahead';
export const MultiSelectionInput = (_a) => {
    var { selections = [] } = _a, props = __rest(_a, ["selections"]);
    const [value, setValue] = React.useState('');
    const onSubmit = (e) => {
        e.preventDefault();
        props.onSubmit(value);
        setValue('');
    };
    const onChange = (e) => {
        setValue(e.target.value);
    };
    let typeaheadRef;
    React.useEffect(() => {
        if (typeaheadRef)
            typeaheadRef.getInput().style.border = '0px';
    }, [typeaheadRef]);
    return (React.createElement("div", { className: C(props.allOptions ? 'p-1 border rounded' : null), style: props.allOptions ? { borderColor: 'gray' } : {} },
        React.createElement("div", { className: C('form-control', 'h-100', 'py-1', 'd-flex', 'justify-content-end', 'align-items-center', props.allOptions ? 'border-0' : '') },
            React.createElement("div", { className: "flex-wrap d-flex" }, selections.map((selection, i) => {
                return (React.createElement("div", { key: selection + i, className: C('badge', 'badge-pill', 'badge-soft-primary', 'd-flex') },
                    React.createElement("span", null, selection),
                    React.createElement(Button, { close: true, size: "sm", onClick: () => props.onClick(selection) })));
            })),
            React.createElement(Form, { onSubmit: onSubmit, className: C('w-100', 'd-inline-block') },
                !props.allOptions && (React.createElement("div", null,
                    React.createElement(Input, { flush: true, name: props.name, onChange: onChange, value: value }))),
                props.allOptions && (React.createElement(Typeahead, { id: "tahd", ref: (ref) => (typeaheadRef = ref), options: props.allOptions || [], onChange: (selected) => {
                        props.onSubmit(selected[0]);
                        if (typeaheadRef) {
                            typeaheadRef.getInstance().clear();
                            typeaheadRef.getInstance().focus();
                        }
                    } }))))));
};
export default MultiSelectionInput;
//# sourceMappingURL=MultiSelectionInput.js.map